import { render, staticRenderFns } from "./repaymentStatusItem.vue?vue&type=template&id=31c78d20&scoped=true"
import script from "./repaymentStatusItem.vue?vue&type=script&lang=js"
export * from "./repaymentStatusItem.vue?vue&type=script&lang=js"
import style0 from "./repaymentStatusItem.vue?vue&type=style&index=0&id=31c78d20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c78d20",
  null
  
)

export default component.exports